<template>
    <div class="container-fluid">
        <validation-observer v-slot="{ validate }" slim>
            <form @submit.prevent="update(validate)">
                <div v-if="vehicle" class="d-flex justify-content-between">
                    <h4>{{ vehicle.make.name }} {{ vehicle.model.name }} <app-vehicle-no :slug="vehicle.slug"/>, {{ vehicle.reg_no }}</h4>
                    <app-button :loading="loading" small>
                        {{ $t('Update') }}
                    </app-button>
                </div>
                <div class="clearfix"></div>
                <vehicle-form :form="form"/>
                <app-button :loading="loading" small>
                    {{ $t('Update') }}
                </app-button>
            </form>
        </validation-observer>
        <hr v-if="form.imgs && form.imgs.length">
        <div class="row" v-if="form.imgs && form.imgs.length">
            <div class="col">
                <h4>{{ $t('Images') }}</h4>
                <div v-for="(file, i) in form.imgs" :key="i" class="float-left" style="position: relative">
                    <span class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg(file.id, i)"/>
                    <img :src="`${envUrl}/vehicles/${file.dbname}`"
                         width="160px"
                         height="auto"
                         class="img-thumbnail"
                         :class="{'ml-2':i > 0}"/>
                    <p :class="{'ml-2':i > 0}">{{ file.name | truncate }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleService from '@services/vehicle.service';
import VehicleForm from './components/Form';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            form: {
                images: []
            },
            loading: false,
            vehicle: null
        };
    },
    computed: {
        ...mapGetters(['envUrl'])
    },
    methods: {
        destroyImg(imgId, index) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            VehicleService.destroyImg(imgId).then(() => {
                this.form.imgs.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    VehicleService.update(this.$route.params.vehicle_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.$router.push({name:'vehicles'});
                    });
                }
            });
        },
        getVehicle(vehicleId){
            VehicleService.show(vehicleId).then(res => {
                this.form = res.vehicle;
                this.vehicle = res.vehicle;
                this.form.liability_sum = res.vehicle.liability_sum / 100;
                this.form.bond = res.vehicle.bond / 100;
            });
        }
    },
    components: {
        VehicleForm
    },
    created() {
        this.getVehicle(this.$route.params.vehicle_id);
    }
};
</script>
